import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {Client} from "../interfaces/Client";
import {links} from "../../utils/links";
import {getJWT} from "../../utils/storageService";
import {useNavigate} from "react-router-dom";
import useClientChangesQuery from "./useClientChangesQuery";

const useClientQuery = () => {

    const jwt = getJWT();
    const navigate = useNavigate()
    const headers = {Authorization: `Bearer ${jwt}`}

    const changesQuery = useClientChangesQuery();

     return useQuery({
         queryKey: ["Client"],
         queryFn: () => axios
             .get<Client>(links.getKunde, {headers})
             .then(res => {
                 const clientData: Client = res.data;

                 // Check if the changesQuery data is available
                 if (changesQuery?.isSuccess) {
                     // Apply the changes to the client data
                     changesQuery?.data?.forEach(change => {
                         if (clientData.hasOwnProperty(change.feld)) {
                             clientData[change.feld] = change.wertAenderung;
                         }
                     });
                 }

                 console.log(clientData)
                 return clientData;
             })
             .catch(error => {
                 localStorage.removeItem("jwt");
                 navigate("/login")
                 console.log(error)
             })
     })
 }

 export default useClientQuery;